var map = {
	"./disaster-portal-map-client-plugin/fragments/authorization/i18n/disaster-authorization.i18n.de-de.js": "zXrd",
	"./disaster-portal-map-client-plugin/i18n/disaster-avoid-polygons.i18n.de-de.js": "FQmH",
	"./ors-disaster-map-client-plugin/fragments/custom-about/i18n/custom-about.i18n.de-de.js": "QIAI",
	"./ors-disaster-map-client-plugin/fragments/region-selector/i18n/region-selector.i18n.de-de.js": "D0jh",
	"./ors-disaster-map-client-plugin/resources/i18n/ors-disaster.i18n.de-de.js": "UD4y"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pqyk";